module.exports = __webpack_public_path__ + "static/media/Sept10-F18.9440632f.png";